import React from 'react';
import { Box, BoxProps, Text } from 'rebass';
import { StatusStyle } from './StatusDot';

type StatusChipProps = BoxProps & {
  status?: StatusStyle;
};

const StatusChip = ({
  status = 'default',
  ...props
}: StatusChipProps): JSX.Element => {
  const variantString = `chip${
    status.charAt(0).toUpperCase() + status.slice(1)
  }`;

  return (
    <Box
      flexShrink={1}
      minWidth={0}
      {...(props as any)}
      variant={variantString}
      sx={{
        ...(props as any).sx,
      }}
    >
      <Text
        variant="body3"
        fontSize={props.fontSize}
        color="inherit"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {props.children}
      </Text>
    </Box>
  );
};

export default StatusChip;
